import { render, staticRenderFns } from "./SmallDetailsOptionBox.vue?vue&type=template&id=bf793cfc"
import script from "./SmallDetailsOptionBox.vue?vue&type=script&lang=js"
export * from "./SmallDetailsOptionBox.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsOptionBox.vue?vue&type=style&index=0&id=bf793cfc&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports